<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1300"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          <div>
            <div>Screen Shots - {{aligner.serialNumber}}</div>
            <div style="font-size: 12px; font-weight: normal"><i>{{decodedSerialNumber}}</i></div>
          </div>
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="onCloseClick()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col>
            <v-card flat style="overflow-y: auto; height: 300px; background-color: #F5F5F5;">
              <ScreenShot
                v-for="(item, index) in aligner.screenShots"
                :id="item.id"
                :image="item.image"
                :thumbnail="item.thumbnail"
                :createdAt="item.createdAt"
                :key="item.id"
                @onDelete="deleteScreenShot"
              >
              </ScreenShot>
              <div
                v-if="aligner.screenShots && aligner.screenShots.length === 0"
                class="pa-3"
                style="background-color: #424242; color: white; text-align: center;"
              >
                NO SCREENSHOTS
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="grey lighten-1" @click="onCloseClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import ScreenShot from './ScreenShot.vue';
import decodeSerialNumber from '../../decodeSerialNumber';

export default {
  components: {
    ScreenShot,
  },

  props: {
    dialog: Boolean,
    aligner: Object,
  },

  computed: {
    decodedSerialNumber() {
      if (this.aligner.serialNumber) {
        const decodedSerialNumber = decodeSerialNumber(this.aligner.serialNumber.toUpperCase());
        if (decodedSerialNumber) {
          return `${decodedSerialNumber.marketingName} ${decodedSerialNumber.buildMonth}/${decodedSerialNumber.buildYear}`;
        }
      }

      return '...';
    },
  },

  methods: {
    onRefreshClick() {
      this.$emit('refresh');
    },

    onCloseClick() {
      this.$emit('close');
    },

    deleteScreenShot(id) {
      console.log(`delete screenshot ${id}`);

      axios
        .delete(`/api/v1/delete_screen_shot?id=${id}`)
        .then(() => {
          this.$emit('refresh', this.aligner);
        });
    },
  },
};
</script>
